import { consts } from '@app/styles'
import type React from 'react'
import { BulletCircle } from '.'

type IBulletStatusKOProps = {}

const BulletStatusKO: React.FC<IBulletStatusKOProps> = props => {
  return <BulletCircle color={consts.colorRed001} />
}

export default BulletStatusKO
